import { useCallback, useState, useRef, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./VideoIntro.module.css";
import NavPanel from "../components/NavPanel";

import ProgressBar from "../components/ProgressBar";
import { AudioContext } from "../AudioContext";

const VideoIntro = () => {
  const navigate = useNavigate();
  const { muted, setMuted } = useContext(AudioContext);
  const videoRef = useRef(null);

  const onFrameContainerClick = useCallback(() => {
    if (videoRef.current.paused) {
      videoRef.current.play()
    } else {
      navigate("/who-best");
    }
  }, [navigate]);

  const handleMuteToggle = () => {
    setMuted((prev) => {
      const newMuted = !prev;
      if (videoRef.current) {
        videoRef.current.muted = newMuted;
      }
      return newMuted;
    });
  };

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.muted = muted;
    }
  }, [muted]);

  return (
    <div className={styles.introVideo}>
      <NavPanel position='full' onClick={onFrameContainerClick} />
      <div className={styles.gradient}></div>

      <div className={styles.player}>
        <video
          ref={videoRef}
          muted={muted}
          autoPlay
          playsInline
          onEnded={() => navigate("/who-best")}
          src={'introvideo.mp4'}
          style={{
          height: '100%',
          width: '100%',
          objectFit: 'cover'
        }}
       />
      </div>
      
      <button
        className={styles.muteButton}
        onClick={handleMuteToggle}
        aria-label={muted ? "Unmute video" : "Mute video"}
      >
        {muted ? (
          // Mute icon (simple SVG)
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line></svg>
        ) : (
          // Unmute icon (simple SVG)
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M19 12c0-1.77-.77-3.29-2-4.29M19 12c0 1.77-.77 3.29-2 4.29M15 8.71V15.3"></path></svg>
        )}
      </button>

      <ProgressBar current='0' />
      
    </div>
  );
};

export default VideoIntro;
